import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'  // 引导页
import Share from './views/Share.vue' // 分享页面
import Indexs from './views/Index.vue' // 首页
import CashOut from './views/cashOut.vue' // 去提现（选择提现方式）
import CashOutSuccess from './views/cashOutSuccess.vue' // 提现申请成功
import Personal from './views/personal.vue' // 个人中心
import NoviceGuide from './views/personalPage/noviceGuide.vue' // 新手指南
import AboutTasks from './views/personalPage/aboutTasks.vue' // 关于做任务
import UserAgreement from './views/personalPage/userAgreement.vue' // 电签协议
import AboutCashOut from './views/personalPage/aboutCashOut.vue' // 关于提现
import TasksMakeMoney from './views/personalPage/tasksMakeMoney.vue' // 做任务赚钱
import ApprenticeMakeMoney from './views/personalPage/apprenticeMakeMoney.vue' // 收徒弟赚钱
import AboutQDS from './views/personalPage/aboutQDS.vue' // 关于钱大师
import CustomerService from './views/personalPage/customerService.vue' // 我的客服
import IncomeDetails from './views/incomeDetails.vue' // 收支明细
import ErweimaShare from './views/erweimaShare.vue' // 您的分享二维码
import FastTasks from './views/fastTasks.vue' // 快速任务
import MissionDetails from './views/missionDetails.vue' // 快速任务-任务详情
import ReservationDetail from './views/reservationDetail.vue' // 预约任务-任务详情
import FastTaskByLaws from './views/fastTaskByLaws.vue' // 快速任务细则
import LeagueTask from './views/leagueTask.vue' // 联盟任务
import CallbackTask from './views/callbackTask.vue' // 回调任务
import CallbackTaskByLaws from './views/callbackTaskByLaws.vue' // 回调任务细则
import CallbackTaskOngoing from './views/callbackTaskOngoing.vue' // 回调任务进行中
import Apprentice from './views/apprentice.vue' // 师徒邀请（收徒分享赚更多）
import ApprenticebByLaws from './views/apprenticebByLaws.vue' // 收徒分享细则
import HighTask from './views/highTask.vue' // 高额任务
import HighTaskExamineByLaws from './views/highTaskExamineByLaws.vue' // 提交审核细则
import HighTaskOngoing from './views/highTaskOngoing.vue' // 高额任务-任务详情
import SubmitAudit from './views/submitAudit.vue' // 提交审核
import AuditStatus from './views/auditStatus.vue' // 审核状态
import GameTask from './views/gameTask.vue' // 游戏任务
import XhyAdvert from './views/xhyAdvert.vue' // 小黑鱼广告
import VipExclusive from './views/vipExclusive.vue' // 会员专享福利
import ExchangeVideoVip from './views/exchangeVideoVip.vue' // 兑换视频会员页
import ExchangeVideoVipByLaws from './views/exchangeVideoVipByLaws.vue' // 兑换视频会员细则
import ChoiceVipCard from './views/choiceVipCard.vue' // 选择vip卡页
import ExchangeVipCard from './views/exchangeVipCard.vue' // 确认兑换会员卡

import CommentTask from './views/comment_task/commentTask.vue'; // 评论任务列表页
import CommentTaskOngoing from './views/comment_task/commentTaskOngoing.vue'; // 评论任务详情页
import Authentication from './views/authentication/authentication.vue'; // 身份认证页面
import mineInformation from './views/authentication/mineInformation.vue'; // 身份认证页2

import Remain from './views/remain.vue'; //留存页面



Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/guide',
      name: 'home',
      component: Home,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/',
      name: 'index',
      component: Indexs,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/share',
      name: 'share',
      component: Share,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/cashOut',
      name: 'cashOut',
      component: CashOut,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/cashOutSuccess',
      name: 'cashOutSuccess',
      component: CashOutSuccess,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/personal',
      name: 'personal',
      component: Personal,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/personal/noviceGuide',
      name: 'noviceGuide',
      component: NoviceGuide
    },
    {
      path: '/personal/noviceGuide/aboutTasks',
      name: 'aboutTasks',
      component: AboutTasks,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/personal/noviceGuide/userAgreement',
      name: 'userAgreement',
      component: UserAgreement,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/personal/noviceGuide/aboutCashOut',
      name: 'aboutCashOut',
      component: AboutCashOut,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/personal/noviceGuide/tasksMakeMoney',
      name: 'tasksMakeMoney',
      component: TasksMakeMoney,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/personal/noviceGuide/apprenticeMakeMoney',
      name: 'apprenticeMakeMoney',
      component: ApprenticeMakeMoney,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/personal/aboutQDS',
      name: 'aboutQDS',
      component: AboutQDS
    },
    {
      path: '/personal/customerService',
      name: 'customerService',
      component: CustomerService
    },
    {
      path: '/incomeDetails',
      name: 'incomeDetails',
      component: IncomeDetails,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/fastTasks/reservationDetail',
      name: 'reservationDetail',
      component: ReservationDetail,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/incomeDetails/erweimaShare',
      name: 'erweimaShare',
      component: ErweimaShare
    },
    {
      path: '/fastTasks',
      name: 'fastTasks',
      component: FastTasks
    },
    {
      path: '/fastTasks/missionDetails',
      name: 'missionDetails',
      component: MissionDetails,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/fastTasks/fastTaskByLaws',
      name: 'fastTaskByLaws',
      component: FastTaskByLaws
    },
    {
      path: '/fastTasks/leagueTask',
      name: 'leagueTask',
      component: LeagueTask,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    // {
    //   path: '/callbackTask',
    //   name: 'callbackTask',
    //   component: CallbackTask
    // },
    {
      path: '/callbackTask/callbackTaskByLaws',
      name: 'callbackTaskByLaws',
      component: CallbackTaskByLaws
    },
    {
      path: '/callbackTask/callbackTaskOngoing',
      name: 'callbackTaskOngoing',
      component: CallbackTaskOngoing,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/apprentice',
      name: 'apprentice',
      component: Apprentice,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/apprentice/apprenticebByLaws',
      name: 'apprenticebByLaws',
      component: ApprenticebByLaws
    },
    {
      path: '/highTask',
      name: 'highTask',
      component: HighTask
    },
    {
      path: '/highTask/highTaskExamineByLaws',
      name: 'highTaskExamineByLaws',
      component: HighTaskExamineByLaws
    },
    {
      path: '/highTask/highTaskOngoing',
      name: 'highTaskOngoing',
      component: HighTaskOngoing
    },
    {
      path: '/highTask/highTaskOngoing/submitAudit',
      name: 'submitAudit',
      component: SubmitAudit,
    },
    {
      path: '/highTask/auditStatus',
      name: 'auditStatus',
      component: AuditStatus
    },
    {
      path: '/gameTask',
      name: 'gameTask',
      component: GameTask,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/commentTask',
      name: 'commentTask',
      component: CommentTask,
    },
    {
      path: '/commentTaskOngoing',
      name: 'commentTaskOngoing',
      component: CommentTaskOngoing,
    },
    {
      path: '/xhyAdvert',
      name: 'xhyAdvert',
      component: XhyAdvert,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/vipExclusive',
      name: 'vipExclusive',
      component: VipExclusive
    },
    {
      path: '/exchangeVideoVip',
      name: 'exchangeVideoVip',
      component: ExchangeVideoVip,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/exchangeVideoVip/choiceVipCard',
      name: 'choiceVipCard',
      component: ChoiceVipCard,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/exchangeVideoVip/exchangeVideoVipByLaws',
      name: 'exchangeVideoVipByLaws',
      component: ExchangeVideoVipByLaws
    },
    {
      path: '/exchangeVideoVip/choiceVipCard/exchangeVipCard',
      name: 'exchangeVipCard',
      component: ExchangeVipCard
    },
    {
      path: '/authentication',
      name: 'authentication',
      component:Authentication
    },
    {
      path: '/mineInformation',
      name: 'mineInformation',
      component:mineInformation
    },
    {
      path: '/remain',
      name: 'remain',
      component:Remain
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
